import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_3.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Nie mogę, spieszę się do kantoratu"
            question=""
            audio={audio}
            answers={{
                ans1: "Kto to jest ten Łukaszewski?",
                ans2: "A daleko do tego Tarszewa?",
            }}
            links={{
                link1: PAGES.p12,
                link2: PAGES.p13,
            }}
            content={
                <div>
                    <ul>
                        <li>Nie mogę, spieszę się do kantoratu.</li>
                        <li>Zlituj się, pomóż mi! Na garnitur zbieram, a Lejmer, mój sąsiad znaczy, obiecał mi garnitur za te śliwki. Sam tego nie wyzbieram… Za tę fatygę zapraszam cię na kolację do Łukaszewskiego, a na nocleg możesz się zatrzymać u mnie. Ile tylko potrzebujesz.</li>
                        <li>A gdzie pan mieszka?</li>
                        <li>Tam w łąkach, w Tarszewie.</li>
                    </ul>
                </div>
            }
        />

    );
}